import { defineMessages } from 'react-intl';

const trns = defineMessages({
  step1: {
    id: 'xn/yXI',
    defaultMessage:
      'Знайдіть потрібні ліки пошуком за назвою або у каталозі ліків'
  },
  step2: {
    id: 'p38HGT',
    defaultMessage:
      'Оберіть аптеку зі зручним розташуванням і вигідною ціною на потрібні ліки'
  },
  step3: {
    id: 'ZjnaPJ',
    defaultMessage:
      'Забронюйте ліки і чекайте СМС-інформування про готовність замовлення'
  },
  step4: {
    id: '6tao7G',
    defaultMessage:
      'Сплачуйте і забирайте своє замовлення в аптеці зручним способом і у зручний час'
  },
  step5: {
    id: 'ZObpPQ',
    defaultMessage: 'Будьте здорові!'
  }
});

export default trns;
